import { useEffect, useState } from 'react';
import { useTwilioAppState } from '../state/';

export default function useTrack(publication) {
  const [track, setTrack] = useState(publication && publication.track);
  const { _isMounted } = useTwilioAppState();
    useEffect(() => {
        if (_isMounted && _isMounted.current === true) {
            // Reset the track when the 'publication' variable changes.
            setTrack(publication && publication.track);

            if (publication) {
                const removeTrack = () => setTrack(null);

                publication.on('subscribed', setTrack);
                publication.on('unsubscribed', removeTrack);
                return () => {
                    publication.off('subscribed', setTrack);
                    publication.off('unsubscribed', removeTrack);
                };
            }
        }
    }, [publication, _isMounted]);

  return track;
}
